import React, { Component } from "react"
import styled from 'styled-components'
import {
  Button as AntButton,
  ButtonGroup as ToggleButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem as AntDropdownItem,
} from 'reactstrap'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import * as CONSTANTS from '../../constants'
import SearchIcon from "../../../../static/images/search_icon.svg"
import ShowListRed from "../../../../static/images/show-list-red.svg"
import ShowListWhite from "../../../../static/images/show-list-white.svg"
import HideListRed from "../../../../static/images/hide-list-red.svg"
import HideListWhite from "../../../../static/images/hide-list-white.svg"
import { FONTS, BASE_URL } from '../../../../constants'
import { Button } from '../../../buttons'
import Select, { components } from 'react-select'
import { FiDownload } from 'react-icons/fi'
import axios from 'axios'

export default class Searchbar extends Component {
  state={ tempSearch: '' }

  customStyle = {
    menuList: (base) => ({
      ...base,
      maxHeight: 300,
      overflowY: 'auto',
    }),
    control: (base, state) => ({
      ...base,
      height: 30,
      minHeight: 30,
      maxWidth: 200,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      width: 15,
      height: 20,
      minHeight: 20,
      padding: 0,
    }),
    option: (base, state) => ({
      ...base,
      height: 30,
      minHeight: 30,
      maxWidth: 220,
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: 0,
    }),
    valueContainer: (provided) => ({
      ...provided,
      textOverflow: "ellipsis",
      maxWidth: "80%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "initial",
    }),
  }

  MultiValueContainer = ({ selectProps, data }) => {
    const label = data.label
    const allSelected = selectProps.value
    const index = allSelected.findIndex(selected => selected.label === label)
    const isLastSelected = index === allSelected.length - 1
    const labelSuffix = isLastSelected ? `` : ", "
    const val = `${label}${labelSuffix}`
    return val
  }

  Option = (props) => {
    const submittedLOB = get(props, 'selectProps.submittedLOB', [])
    return (
      <components.Option { ...props }>
        <Row>
          <input
            style={ { marginRight: 5 } }
            type='checkbox'
            checked={ get(props, 'isSelected') }
          />
          {/* <Circle color={ !submittedLOB.includes(get(props, 'value')) ? '#CCCCCC' : '#5CB85C' } />
          { `${get(props, 'label')}` } */}
          { `${get(props, 'label')}` }
        </Row>
      </components.Option>
    )
  }

  exportProject = async () => {
    const projectId = get(this.props, 'projectByID._id')
    const access_token = localStorage.getItem('access_token')
    const response = await axios.get(`${BASE_URL}/projects/${projectId}/resources/exports`, { headers: {'authorization': `bearer ${access_token}`} })
    if (response) {
      window.open(response.data.url, '_blank')
    }
  }

  render() {
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const project_type = get(projectByID, 'project_type')
    // const $can_edit = get(projectByID, '$can_edit')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    // const canEdit = $can_edit
    const IsSupport = project_type === CONSTANTS.SUPPORT
    // const fallbackNanOrInfinity = (number) => {
    //   return number === 'NaN' || number === Infinity ? '0.00' : number
    // }
    // const total_resource_man_days = isPresale ? get(presale_snapshot, '$total_resource_man_days', '-') : get(projectByID, '$total_resource_man_days', '-')
    // const total_resource_man_days_avg = isPresale ? get(presale_snapshot, '$total_resource_man_days_avg', '-') : fallbackNanOrInfinity(get(projectByID, '$total_resource_man_days_avg', '-'))
    // const total_resource_cost = isPresale ? get(presale_snapshot, '$total_resource_cost', '-') : get(projectByID, '$total_resource_cost', '-')
    // const total_resource_price = isPresale ? get(presale_snapshot, '$total_resource_price', '-') : get(projectByID, '$total_resource_price', '-')

    const override_total_resource_mandays = get(this.props, 'override_total_resource_mandays', 0)
    const override_avg_resource_man_day_rate = get(this.props, 'override_avg_resource_man_day_rate', 0)
    const override_total_resource_cost = get(this.props, 'override_total_resource_cost', 0)
    const override_total_resource_price = get(this.props, 'override_total_resource_price', 0)

    const sum_man_days = get(projectByID, '$service_man_days')
    const weight_man_days = get(projectByID, '$weight_man_days')
    // // const revenue_by_man_days = get(projectByID, '$revenue_by_man_days')
    const contract_revenue_by_wmd = get(projectByID, '$contract_revenue_by_wmd')

    const lobOptions = get(this.props, 'lobOptions', [])
    const moduleOptions = get(this.props, 'moduleOptions', [])
    const handleSearch = get(this.props, 'handleSearch')
    const clickCalculate = get(this.props, 'clickCalculate')
    // const editResourceCost = get(this.props, 'editResourceCost')
    const hide = get(this.props, 'hide')
    const editResource = get(this.props, 'editResource')
    const hideInfo = get(this.props, 'hideInfo')
    // const clickEdit = get(this.props, 'clickEdit')
    // const cancelEdit = get(this.props, 'cancelEdit')
    const handleInput = get(this.props, 'handleInput')
    const handleAutoAdd = get(this.props, 'handleAutoAdd')
    const clickAddResource = get(this.props, 'clickAddResource')
    return (
      <SearchDivStyle>
        <SearchEmployeeDiv>
          <SearchField
            onChange={ (e) => {
              if (e.target.value === '') handleSearch(e.target.value)
              this.setState({ tempSearch: e.target.value })
            } }
            onKeyDown={ (e) => {
              if (e.keyCode === 13) handleSearch(this.state.tempSearch)
            } }
            placeholder={ 'Search By Employee' }
          />
          <ToggleGroup>
            <ToggleButton
              style={ {
                backgroundColor: !hide ? '#AD2624' : '#FFFFFF',
                border: '1px solid #AD2624',
              } }
              onClick={ () => hideInfo(false) }
            >
              <ImageButton alt='' src={ !hide ? HideListWhite : HideListRed } />
            </ToggleButton>
            <ToggleButton
              style={ {
                backgroundColor: hide ? '#AD2624' : '#FFFFFF',
                border: '1px solid #AD2624',
              } }
              onClick={ () => hideInfo(true) }
            >
              <ImageButton alt='' src={ hide ? ShowListWhite : ShowListRed } />
            </ToggleButton>
          </ToggleGroup>
          <MultiSelectWrapper>
            <MultiSelect
              styles={this.customStyle}
              closeMenuOnSelect={ false }
              isMulti
              isSearchable={ false }
              isClearable={ false }
              hideSelectedOptions={ false }
              backspaceRemovesValue={ false }
              placeholder={'Filter LOB'}
              onChange={(values) => this.props.handleFilterLOB(values.map(v => v.value))}
              options={ orderBy(lobOptions.map(l => ({ value: l.lob, label: l.lob })),  ['value'])}
              components={ { Option: this.Option, MultiValueContainer: this.MultiValueContainer } }
            />
          </MultiSelectWrapper>
          {/* <MultiSelectWrapper>
            <MultiSelect
              styles={this.customStyle}
              closeMenuOnSelect={ false }
              isMulti
              isSearchable={ false }
              isClearable={ false }
              hideSelectedOptions={ false }
              backspaceRemovesValue={ false }
              placeholder={'Filter Module'}
              onChange={(values) => this.props.handleFilterModule(values.map(v => v.value))}
              options={ orderBy(moduleOptions.map(m => ({ value: m.module, label: m.module })),  ['value'])}
              components={ { Option: this.Option, MultiValueContainer: this.MultiValueContainer } }
            />
          </MultiSelectWrapper> */}
          {!editResource && <div style={ { display: 'flex', justifyContent: 'flex-end', margin: 'auto', marginRight: '0' } }>
            <Button
              icon={ <FiDownload style={ { fontSize: 16 } } /> }
              theme='#D44B49'
              width='110px'
              height='26px'
              onClick={ () => this.exportProject() }
            >
              Export
            </Button>
          </div>}
          { !isPresale &&
            <React.Fragment>{ editResource &&
              (<ButtonGroup style={ { display: 'flex', justifyContent: 'flex-end' } }>
              {/* { !editResource && canEdit &&
                <LastRightButton color='success' onClick={ () => clickEdit() }>Edit</LastRightButton>
              }
              { editResource &&
                <RightButton color='success' onClick={ () => editResourceCost() }>Save</RightButton>
              }
              { editResource &&
                <RightButton onClick={ () => cancelEdit() }>Cancel</RightButton>
              } */}
              { editResource &&
              <Button
                theme='#D44B49'
                width='110px'
                height='26px'
                style={ { marginRight: 12 } }
                onClick={ () => clickCalculate() }
              >
                Calculate
              </Button>
              }
              { editResource &&
              <Button
                theme='#D44B49'
                width='110px'
                height='26px'
                style={ { marginRight: 12 } }
                onClick={ () => handleAutoAdd() }
              >
                Fill Man-Days
              </Button>
              }
              { editResource &&
                <Dropdown>
                  <ItemDropdown>
                    + Add Resource
                  </ItemDropdown>
                  <DropdownMenu>
                    <DropdownItem onClick={ () => clickAddResource('Employee') }>Employee</DropdownItem>
                    <DropdownItem onClick={ () => clickAddResource('Subcontract') }>Subcontract</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              }
            </ButtonGroup>
            )}</React.Fragment>
          }
        </SearchEmployeeDiv>
        <div style={ { display: 'flex', flexDirection: 'row', flexFlow: 'column' } }>
          { IsSupport &&
          <Header>
            <TextHeader>&nbsp;&nbsp;&nbsp;Total Man-Days</TextHeader>
            <TextNumber>
              <NumberField
                name="override_total_resource_mandays"
                value={ isPresale ?
                  presale_snapshot.override_total_resource_mandays : override_total_resource_mandays }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                disabled={ !editResource }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  handleInput(e)
                } }
              />
            </TextNumber>
            <TextHeader>Avg. Man-Day Rate</TextHeader>
            <TextNumber>
              <NumberField
                name="override_avg_resource_man_day_rate"
                value={ isPresale ?
                  presale_snapshot.override_avg_resource_man_day_rate : override_avg_resource_man_day_rate }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                disabled={ !editResource }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  handleInput(e)
                } }
              />
            </TextNumber>
            <TextHeader>Total Cost (฿)</TextHeader>
            <TextNumber>
              <NumberField
                name="override_total_resource_cost"
                value={ isPresale ?
                  presale_snapshot.override_total_resource_cost : override_total_resource_cost }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                disabled={ !editResource }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  handleInput(e)
                } }
              />
            </TextNumber>
            <TextHeader>Total Price (฿)</TextHeader>
            <TextNumber>
              <NumberField
                name="override_total_resource_price"
                value={ isPresale ?
                  presale_snapshot.override_total_resource_price : override_total_resource_price }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                disabled={ !editResource }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  handleInput(e)
                } }
              />
            </TextNumber>
          </Header>
          }
          { !IsSupport &&
          <Header>
            <TextHeader>&nbsp;&nbsp;&nbsp;Total Man-Days</TextHeader>
            <TextNumber>
              { sum_man_days }
            </TextNumber>
            <TextHeader>Weighted MD</TextHeader>
            <TextNumber>
              { weight_man_days }
            </TextNumber>
            <TextHeader>Rev/Weighted MD</TextHeader>
            <TextNumber>
              {/* { revenue_by_man_days } */}
              { contract_revenue_by_wmd }
            </TextNumber>
          </Header>
          }
        </div>
      </SearchDivStyle>
    )
  }
}
const SearchDivStyle = styled.div`
  background-color: #ffffff ;
  width: 100%;
`
const Dropdown = styled(UncontrolledDropdown)`
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    height: 26px;
    padding: 0;
  }
`

const DropdownItem = styled(AntDropdownItem)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`

const ItemDropdown = styled(DropdownToggle)`
  width: 125px;
  background: #D44B49;
  border: 1px solid #D44B49;
  color: #FFFFFF;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: none;

  :hover {
    background: #c82333;
    border: 1px solid #bd2130;
    color: #FFFFFF;
  }
`

const ButtonGroup = styled.div`
  text-align: right;
  margin: auto;
  margin-right: 0px !important;
  width: 100%;
  font-family: ${FONTS.GOTHAM_MEDIUM};
`

const SearchEmployeeDiv = styled.div`
  height: 40px;
  padding: 0 15px;
  display: flex;
`

const Header = styled.div`
  border: 1px solid white ;
  height: 30px;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

const TextHeader = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  margin: auto;
  margin-right: 20px;
`

const TextNumber = styled.p`
   font-family: ${FONTS.GOTHAM_MEDIUM} !important;
   font-size: ${FONTS.SMALL_SIZE};
   margin:auto;
   margin-left: 0%;
`

const MultiSelectWrapper = styled.div`
  margin-top: 5px;
  margin-left: 1%;
  font-size: 12px;
`

const MultiSelect = styled(Select)`
  /* height: 25px; */
  width : 220px;
  margin-right: 10px;
  font-family: ${FONTS.GOTHAM};
`

const SearchField = styled.input`
  background: url(${SearchIcon}) no-repeat scroll 4px 4px;
  background-size: 15px 15px;
  padding-left:30px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width: 20;
  height: 25px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: auto;
  margin-left: 0px !important;
  margin-right: 1%;
  box-sizing: border-box;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
    padding-top:35px;
  }
`

const NumberField = styled(NumberFormat)`
    font-family: ${FONTS.GOTHAM} !important;
    width : 80% ;
    font-size: ${FONTS.SMALL_SIZE};
    margin-left: 5% ;
    margin-right: 10% ;
    border-radius: 5px;
    border: ${props => {
    if (props.invalid) {
      return '1px solid red'
    }
    return '1px solid #CCCCCC'
  }};
    background-color: ${props => {
    const status = props.disabled
    if (status === !get(this.props, 'edit_resource')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`

const ToggleButton = styled(AntButton)`
  float: left;
  width: 50px;
  height: 70%;
  font-size: 12px !important;
  padding: 0px;
  margin-top: 5px;
`

const ImageButton = styled.img`
  width: 50%;
  height: 50%;
`

const ToggleGroup = styled(ToggleButtonGroup)`
  margin:auto;
  margin-right: 0px !important;
  margin-left: 10px !important;
  height: 30px ;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`


// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-resource-cost/index.js